import { Navigate } from 'react-router';

import { paths } from 'src/routes/paths';

import { HQ_TENANT_ID } from 'src/constants/tenant-constant';

import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

/**
 * 登录后按租户跳转默认首页
 * - 总部：平台工作台
 * - 加盟商：资产管理（业务菜单首项）
 */
export function RoleScopeRedirect({ redirectTo }: { redirectTo?: string }) {
  const { user } = useAuthContext();

  const target =
    redirectTo || (user?.tenantId === HQ_TENANT_ID ? paths.hq.overview : paths.dashboard.root);

  return <Navigate to={target} replace />;
}
